// The wall screen's frame: a fixed 1920×1080 CSS-pixel layout scaled to fit
// the window, so a 4K screen gets the same layout at twice the size and
// nothing reflows. Type inside never goes under --text-board-min (22 px).
import React, { useEffect, useState } from "react";

export const BOARD_W = 1920;
export const BOARD_H = 1080;

export function fitScale(w: number, h: number) {
  return Math.min(w / BOARD_W, h / BOARD_H);
}

export function BoardFrame({ children }: { children: React.ReactNode }) {
  const [box, setBox] = useState(() => ({ w: typeof window === "undefined" ? BOARD_W : window.innerWidth, h: typeof window === "undefined" ? BOARD_H : window.innerHeight }));
  useEffect(() => {
    const on = () => setBox({ w: window.innerWidth, h: window.innerHeight });
    window.addEventListener("resize", on);
    return () => window.removeEventListener("resize", on);
  }, []);
  const s = fitScale(box.w, box.h);
  // Centre the scaled frame (letterboxing on screens that aren't 16:9).
  const x = (box.w - BOARD_W * s) / 2, y = (box.h - BOARD_H * s) / 2;
  return (
    <div className="board-viewport">
      <div className="board-frame" style={{ transform: `translate(${x}px, ${y}px) scale(${s})` }} data-testid="board-frame">
        {children}
      </div>
    </div>
  );
}
